import MailChimp from '@/components/icons/MailChimp'
import Klaviyo from '@/components/icons/Klaviyo'
import Maropost from '@/components/icons/Maropost'
import Sendlane from '@/components/icons/Sendlane'

export const emailProviders = {
    mailchimp: {
        name: 'MailChimp',
        type: 'mailchimp',
        link: 'https://mailchimp.com/',
        apiKeyLink: 'https://eepurl.com/dyijVH',
        icon: <MailChimp sx={{ width: 150, height: 32 }} />,
        formDescription: `Unique Identifier that provides authentication access. This is needed to correctly connect your custom email provider.`,
    },
    klaviyo: {
        name: 'Klaviyo',
        type: 'klaviyo',
        link: 'https://www.klaviyo.com/',
        icon: <Klaviyo sx={{ width: 108, height: 32 }} />,
        apiKeyLink:
            'https://www.klaviyo.com/create-private-api-key?scopes=campaigns:read,campaigns:write,events:read,events:write,list:read,list:write,profiles:read,profiles:write,subscriptions:read,subscriptions:write',
        formDescription: `Click the link below to generate a new Private API key. This should automatically assign the correct permissions OR you can select the “Full Access Key” option to successfully complete the integration.`,
    },
    maropost: {
        name: 'Maropost',
        type: 'maropost',
        link: 'https://www.maropost.com/',
        title: 'Credentials',
        icon: <Maropost sx={{ width: 155, height: 42 }} />,
        formDescription: `Unique Identifier that provides authentication access. This is needed to correctly connect your custom email provider.`,
    },
    sendlane: {
        name: 'Sendlane',
        type: 'sendlane',
        link: 'https://www.sendlane.com/',
        title: 'Credentials',
        icon: <Sendlane sx={{ width: 150, height: 42 }} />,
        formDescription: `Unique Identifier that provides authentication access. This is needed to correctly connect your custom email provider.`,
    },
}

export const CONFIG_TYPES = {
    SECRET: 'secret',
    LIST_ID: 'list_id',
    LIST_NAME: 'list_name',
    API_KEY: 'api_key',
    ACCOUNT_ID: 'account_id',
    ACCESS_TOKEN: 'access_token',
    INTEGRATION_TOKEN: 'integration_token',
}

export const MARKETING_EMAIL_PROVIDERS_TYPES = {
    MAILCHIMP: 'mailchimp',
    KLAVIYO: 'klaviyo',
    MAROPOST: 'maropost',
    sendlane: 'sendlane',
}
